/**
 * Format a number as currency with thousand separators (Colombian format)
 * @param {number|string} value - The numeric value to format
 * @returns {string} Formatted string with dots as thousand separators
 * @example formatCurrency(50000) // "50.000"
 */
export const formatCurrency = (value) => {
    if (!value && value !== 0) return '';
    // Parse as number first to handle decimals correctly
    const numericValue = typeof value === 'string' ? parseFloat(value.replace(/[^\d.-]/g, '')) : parseFloat(value);
    if (isNaN(numericValue)) return '';
    // Round to remove decimals and format with thousand separators
    return Math.round(numericValue).toLocaleString('es-CO');
};

/**
 * Parse a formatted currency string to raw numeric value
 * @param {string} formattedValue - Formatted currency string
 * @returns {string} Raw numeric string (digits only)
 * @example parseCurrency("50.000") // "50000"
 */
export const parseCurrency = (formattedValue) => {
    if (!formattedValue) return '';
    return formattedValue.replace(/\D/g, '');
};

/**
 * Format a number with thousand separators
 * @param {number|string} value - The value to format
 * @returns {string} Formatted number string
 * @example formatNumber(1000) // "1.000"
 */
export const formatNumber = (value) => {
    if (!value && value !== 0) return '';
    return parseInt(value).toLocaleString('es-CO');
};
